<div class="activity-tab"
     tabindex="0"
     role="button"
     [class.active]="isActive"
     [class.read-only]="activityStatus === 'submitted' || activityStatus === 'approved'"
     [class.status-draft]="activityStatus === 'draft'"
     [class.status-submitted]="activityStatus === 'submitted'"
     [class.status-approved]="activityStatus === 'approved'"
     [class.status-rejected]="activityStatus === 'rejected'"
     (click)="selectTab.emit()"
     (keyup.enter)="selectTab.emit()">
  <div class="activity-header">
    <span class="activity-label">Activity {{ activityNumber }}</span>
    @if (cleanDisplayName) {
      <span class="activity-owner">{{ cleanDisplayName }}</span>
    }
  </div>
  <span class="activity-badges">
    <span class="completion-badge">{{ completionCount }}/{{ totalQuestions }}</span>
    @if (noAnswerCount > 0) {
      <span class="number-badge">No: {{ noAnswerCount }}</span>
    }
    @if (activityStatus) {
      <span [class]="'status-badge status-' + activityStatus">{{ activityStatus | titlecase }}</span>
    }
    @if (activityStatus === 'rejected' && isActionRequiredOnReject) {
      <span class="action-required-indicator" title="Action Required">
        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="6" cy="6" r="5" fill="#ea580c" stroke="#fff" stroke-width="1"/>
          <path d="M6 3V6.5M6 8.5H6.01" stroke="#fff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </span>
    }
  </span>
</div>
